import { Link } from "react-router-dom";
import { isNew, money, productImages, sized } from "@/lib/api";

export const ProductCard = ({ product, index = 0 }) => {
  const [a, b] = productImages(product);
  const price = product?.priceRange?.minVariantPrice;
  const compare = product?.compareAtPriceRange?.minVariantPrice;
  const onSale = compare && Number(compare.amount) > Number(price?.amount);
  return (
    <Link to={`/products/${product.handle}`} data-testid={`product-card-${product.handle}`} className="group block">
      <div className="relative aspect-[3/4] overflow-hidden bg-[#EEEBE5]">
        {a && (
          <img
            src={sized(a.url, 900)}
            srcSet={`${sized(a.url, 480)} 480w, ${sized(a.url, 900)} 900w`}
            sizes="(min-width: 768px) 25vw, 50vw"
            alt={a.altText || product.title}
            loading={index < 4 ? "eager" : "lazy"}
            className="absolute inset-0 h-full w-full object-contain p-[10%] mix-blend-multiply transition-[transform,opacity] duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.035]"
          />
        )}
        {b && (
          <div className="absolute inset-0 isolate bg-[#EEEBE5] opacity-0 transition-opacity duration-700 group-hover:opacity-100">
            <img
              src={sized(b.url, 900)}
              alt=""
              loading="lazy"
              className="h-full w-full object-contain p-[10%] mix-blend-multiply transition-transform duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.035]"
            />
          </div>
        )}
        <div className="absolute left-3 top-3 flex gap-1.5">
          {isNew(product) && <span className="label bg-[#F4F2EE] px-2 py-1 text-[10px] text-[#E2541B]">New</span>}
          {!product.availableForSale && <span className="label bg-[#111111] px-2 py-1 text-[10px] text-[#F4F2EE]">Sold out</span>}
        </div>
      </div>
      <div className="flex items-start justify-between gap-3 pt-3">
        <h3 className="font-display text-[13px] font-medium uppercase leading-snug tracking-[-0.01em] md:text-sm">{product.title}</h3>
        <p data-testid={`product-card-price-${product.handle}`} className="label shrink-0 pt-0.5 transition-opacity duration-500 md:opacity-0 md:group-hover:opacity-100 md:group-focus-visible:opacity-100">
          {onSale && <s className="mr-1.5 text-[#111111]/50">{money(compare)}</s>}
          {money(price)}
        </p>
      </div>
      {product.productType && <p className="label mt-1 text-[10px] text-[#111111]/60">{product.productType}</p>}
    </Link>
  );
};

export const ProductGrid = ({ products, testid }) => (
  <div data-testid={testid} className="grid grid-cols-2 gap-x-3 gap-y-10 md:grid-cols-4 md:gap-x-5 md:gap-y-14">
    {products.map((p, i) => (
      <ProductCard key={p.id} product={p} index={i} />
    ))}
  </div>
);

export const GridSkeleton = ({ n = 4 }) => (
  <div className="grid grid-cols-2 gap-x-3 gap-y-10 md:grid-cols-4 md:gap-x-5">
    {Array.from({ length: n }).map((_, i) => (
      <div key={i}>
        <div className="aspect-[3/4] animate-pulse bg-[#E8E5DF]" />
        <div className="mt-3 h-3 w-2/3 bg-[#E8E5DF]" />
      </div>
    ))}
  </div>
);

export const StoreNotice = ({ error }) => (
  <div data-testid="store-notice" className="border-y py-16 text-center">
    <p className="label text-[#111111]/70">{error === "Shopify is not connected yet" ? "Store connecting — products appear here shortly" : "Products are unavailable right now"}</p>
  </div>
);
